export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-950">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg text-background-50">飞飞漫画网</span>
            </div>
            <p className="text-foreground-400 text-sm leading-relaxed mb-4">
              飞飞漫画网是专业的免费漫画在线阅读平台，涵盖国漫、日漫、韩漫等海量资源。下拉式阅读体验流畅，每日实时更新，让你免费看漫画追更无忧。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" onClick={(e) => handleNavClick(e, '#hero')} className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer no-underline">
                <i className="ri-home-line text-background-50 text-sm"></i>
              </a>
              <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')} className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer no-underline">
                <i className="ri-mail-line text-background-50 text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '首页', href: '#hero' },
                { label: '热门推荐', href: '#cards' },
                { label: '常见问题', href: '#faq' },
                { label: '更新动态', href: '#updates' },
                { label: '热门话题', href: '#topics' },
              ].map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  onClick={(e) => handleNavClick(e, item.href)}
                  className="text-foreground-400 text-sm hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap no-underline"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">漫画分类</h4>
            <div className="flex flex-col gap-2">
              {['国漫专区', '日漫精选', '韩漫热门', '完结漫画', '最新上架'].map((cat) => (
                <span key={cat} className="text-foreground-400 text-sm whitespace-nowrap">
                  {cat}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">合作伙伴</h4>
            <p className="text-foreground-500 text-sm leading-relaxed">
              更多合作伙伴即将入驻，敬请期待。如有合作意向，欢迎通过联系方式与我们沟通。
            </p>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} 飞飞漫画网. 本站所有漫画资源均来自互联网，仅供爱好者交流学习使用。
          </p>
          <div className="flex items-center gap-4">
            <span className="text-foreground-500 text-xs cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">用户协议</span>
            <span className="text-foreground-500 text-xs cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</span>
          </div>
        </div>
      </div>
    </footer>
  );
}